import { mockAccount } from './routes/mockAccount'
import { mockChains } from './routes/mockChains'
import { mockAccountBalances } from './routes/mockAccountBalances'
import { mockNotification } from './routes/mockNotification'
import { mockAccountNonce } from './routes/mockAccountNonce'
import { mockIndexes } from './routes/mockIndexes'
import { mockFeeRate } from './routes/mockFeeRate'
import { mockAnnouncement } from './routes/mockAnnouncement'
import { mockSpotOpenOrders } from './routes/mockSpotOpenOrders'
import { mockPerpOpenOrders } from './routes/mockPerpOpenOrders'
import { mockPositions } from './routes/mockPositions'
import { mockWssToken } from './routes/mockWssToken'
import { mockAccountActivateStatus } from './routes/mockAccountActivateStatus'
import { mockTrades } from './routes/mockTrades'
import { mockOrderbook } from './routes/mockOrderbook'
import { registerMocks } from './register'
import { mockBars } from './routes/mockBars'
import { mockRecentTrades } from './routes/mockRecentTrades'
import { mockEarnsDetail } from './routes/mockEarnsDetail'
import { mockEarnsToday } from './routes/mockEarnsToday'
import { mockEarnsLucky } from './routes/mockEarnsLucky'

registerMocks((mock) => {
  // Basic Mocks
  mock(mockChains, 0)
  mock(mockIndexes, 0)
  mock(mockTrades, 0)
  mock(mockOrderbook, 0)
  mock(mockBars, 0)
  mock(mockRecentTrades, 0)

  // Account Mocks
  mock(mockAccount, 0)
  mock(mockAccountActivateStatus, 0)
  mock(mockAccountBalances, 0)
  mock(mockAccountNonce, 0)
  mock(mockWssToken, 0)

  // Notification Mocks
  mock(mockNotification, 0)
  mock(mockAnnouncement, 0)

  // Trading Fee Mocks
  mock(mockFeeRate, 0)

  // User Order Mocks
  mock(mockSpotOpenOrders, 0)
  mock(mockPerpOpenOrders, 0)
  mock(mockPositions, 0)

  // Earns Mocks
  mock(mockEarnsDetail, 0)
  mock(mockEarnsToday, 0)
  mock(mockEarnsLucky, 0)
})
